import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "./provider";

// Route-element guard for authenticated areas. Was copy-pasted byte-identical into
// passport-web / board-web / dsp-web; now shared. Renders nothing while the session
// is loading, redirects to /login when unauthenticated, otherwise renders the matched
// child route.
export function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuthContext();
  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <Outlet />;
}
